import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import HomeScreen from "./Screens/HomeScreen";
import PayScreen from "./Screens/PayScreen";
import ReceiptScreen from "./Screens/ReceiptScreen";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/receipts/:document_id" element={<ReceiptScreen />} />
          <Route path="/:document_id" element={<PayScreen />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
